var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8029_2883)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8029_2883",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8029_2883)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8029_2883",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8029_2883)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.3726 18.6274 0 12 0C5.3726 0 0 5.3726 0 12C0 18.6274 5.3726 24 12 24Z",
    fill: "url(#paint0_linear_8029_2883)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7282 11.4474C16.7282 14.3639 14.3639 16.7282 11.4474 16.7282C8.53082 16.7282 6.1665 14.3639 6.1665 11.4474C6.1665 8.53082 8.53082 6.1665 11.4474 6.1665C14.3639 6.1665 16.7282 8.53082 16.7282 11.4474ZM13.1023 11.854C13.344 11.854 13.5398 11.6581 13.5398 11.4165C13.5398 11.1749 13.344 10.979 13.1023 10.979H9.80251C9.56088 10.979 9.36501 11.1749 9.365 11.4165C9.365 11.6581 9.56088 11.854 9.8025 11.854H13.1023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4821 15.4822C15.653 15.3113 15.93 15.3113 16.1008 15.4822L17.5592 16.9405C17.73 17.1114 17.73 17.3883 17.5592 17.5592C17.3883 17.73 17.1113 17.73 16.9405 17.5592L15.4821 16.1009C15.3113 15.93 15.3113 15.653 15.4821 15.4822Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8029_2883",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8029_2883"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOut);
export default __webpack_public_path__ + "static/media/ZoomOut.da2ccc6a1ce20ccc51433dc18fa13d9e.svg";
export { ForwardRef as ReactComponent };